import React from 'react';
import { useAuth } from '../context/AuthContext';
import MonteurPlanning from '../pages/MonteurPlanning';
import WerkvoorbereiderPlanning from '../pages/WerkvoorbereiderPlanning';

const PlanningRouter = () => {
  const { gebruiker } = useAuth();
  
  console.log('PlanningRouter - gebruiker:', gebruiker);
  console.log('PlanningRouter - rol:', gebruiker?.rol);
  
  if (gebruiker?.rol === 'monteur') {
    console.log('PlanningRouter - TOON MONTEUR PLANNING');
    return <MonteurPlanning />;
  }
  
  if (gebruiker?.rol === 'werkvoorbereider' ||
      gebruiker?.rol === 'bedrijf_admin' ||
      gebruiker?.rol === 'super_admin' ||
      gebruiker?.rol === 'hoofdbeheerder') {
    console.log('PlanningRouter - TOON WERKVOORBEREIDER PLANNING');
    return <WerkvoorbereiderPlanning />;
  }
  
  // Default naar monteur planning
  console.log('PlanningRouter - DEFAULT naar monteur');
  return <MonteurPlanning />;
};

export default PlanningRouter;
